<template>
  <div class="tw-w-full tw-flex tw-flex-col tw-gap-3">
    <div class="tw-flex tw-items-end tw-gap-2 tw-text-xl tw-font-bold">
      <span class="tw-text-[#F1583D]">2.</span> 
      <span>Benchmark</span>
      <span class="tw-text-sm tw-italic tw-font-normal">(optional)</span>
    </div>
    <div class="tw-flex tw-items-center tw-gap-2">
      <PortfolioSearchSelect
        placeholder="Search for benchmark portfolio"
        @selected="handleSelected"
      />
      <CreateBenchmarkButton />
    </div>

    <SelectedPortfolios
      portfolio-type="benchmark"
      placeholder="None selected"
      :portfolios="checkupStore.benchmark ? [checkupStore.benchmark] : []"
      @remove="handleRemove"
    />
  </div>
</template>

<script>
import PortfolioSearchSelect from './PortfolioSearchSelect.vue';
import SelectedPortfolios from './SelectedPortfolios.vue';
import CreateBenchmarkButton from './CreateBenchmarkButton.vue';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore';
import { mapStores } from 'pinia';

export default {
  name: 'BenchmarkSelectWrapper',
  components: { PortfolioSearchSelect, SelectedPortfolios, CreateBenchmarkButton },
  computed: {
    ...mapStores(useCheckupStore, useAdvisorStore),
  },
  methods: {
    handleSelected(portfolio) {
      console.log('SELECTED BENCHMARK', portfolio);
      this.checkupStore.setBenchmark(portfolio);
    },
    handleRemove(portfolio) {
      this.checkupStore.removePortfolio(portfolio);
    },
  },
};
</script>
